import React, { useState, useEffect } from 'react'
import { Outlet, useLocation } from "react-router-dom"
import '../../styles/TracingInfoPage.css'

import * as vizSeaHouseMgt from '../../viz/SeaHouseMgt.jsx'

const DEBUG = true

export default function TracingInfoPage() {
  const [houseBl, setHouseBl] = useState('')
  const [tableData, setTableData] = useState([])
  const [searched, setSearched] = useState(false)

  // 가짜 데이터 (API 연동 시 여기만 바꾸면 됨)
  const mockData = [
    {
      no: 1,
      hbl: 'HKPUF02000224TS',
      etaBusan: '..',
      destination: 'HOCHIMINH, VIETNAM',
      vslName: 'SAWASDEE SIRIUS',
      voyage: '2404S',
      package: '1',
      weightVolume: '109.5 / 1.331',
      etd: '2024.03.24',
      onbd_ymd: '2024.03.24',
      issue_ymd: '2024.03.24',
      eta: '2024.03.29',
      nf: 'P',
      pc: 'P',
    }
  ]

  function normalizeHouseBl(value) {
    const input = value.trim().toUpperCase()

    if (input.endsWith("TS")) {
      return input
    }

    if (input.endsWith("T")) {
      return input + "S"
    }

    return input + "TS"
  }

  const handleSearch = async (e) => {
    e.preventDefault()
    setSearched(true)

    // 실제 API 조회할 때 houseBl 보내서 fetch 하면 됨
    if (houseBl.trim() === '') {
      setTableData([])
      return
    }

    const nHouseBl = normalizeHouseBl(houseBl)
    console.log('nHouseBl:', nHouseBl)// 1. Import 검색
    let importResult = await hbl_SearchList_Import(nHouseBl.trim())

    if (!importResult || importResult.list.length === 0) {
      importResult = await hbl_SearchList_Import(houseBl.trim())
    }

    if (!importResult || importResult.list.length === 0) {
      setTableData([])
      return
    }

    const mainDoc = importResult.list[0]
    const tsHblNo = mainDoc?.TS_HBL_NO?.trim()

    let exportVslName = ''
    let exportETD = ''
    let exportATD = ''
    let exportETA = ''

    if (tsHblNo) {
      console.log('TS_HBL_NO 발견 → Export 검색 시도:', tsHblNo)
      const exportResult = await hbl_SearchList_Export(tsHblNo)

      if (exportResult && exportResult.list.length > 0) {
        exportVslName = exportResult.list[0].vslName || ''
        exportETD = exportResult.list[0].etd || ''
        // exportATD = exportResult.list[0].onbd_ymd || ''
        exportATD = exportResult.list[0].issue_ymd || ''
        exportETA = exportResult.list[0].eta || ''
        console.log('Export vslName 적용:', exportVslName)
      } else {
        console.log('Export 검색 실패 또는 데이터 없음')
      }
    } else {
      console.log('TS_HBL_NO 값이 없음 → 2nd VSL 표시 안 함')
    }

    // Import 데이터를 기반으로 하되, vslName만 Export 값으로 교체
    const finalList = importResult.list.map((doc, index) => ({
      no: index + 1,
      hbl: doc.hbl,
      etaBusan: '', // 여전히 없으면 빈값
      destination: doc.destination,
      vslName: exportVslName || doc.vslName || '',  // ← 여기서 Export 값 우선 적용
      voyage: doc.voyage,
      package: doc.package,
      weightVolume: doc.weightVolume,
      etd: exportETD || doc.etd || '', // ← 여기서 Export 값 우선 적용
      onbd_ymd: exportATD || doc.onbd_ymd || '',
      issue_ymd: exportATD || doc.issue_ymd || '',
      eta: exportETA || doc.eta || '', // ← 여기서 Export 값 우선 적용
      nf: doc.nf,
      pc: convertPC(doc.pc),
      // tshblno: doc.TS_HBL_NO,   // 디버깅용으로만 필요하면 남겨두기
    }))

    setTableData(finalList)
  }

  async function hbl_SearchList_Import(hblValue) {
    if (DEBUG) console.log('hbl_SearchList_Import 시작', hblValue)

    const args0 = {
      DOMAIN: "NTLK.ELVIS21.COM",
      OFFICE_CD: "NTLK",
      HBL_NO: hblValue,
    }

    try {
      const ret = await vizSeaHouseMgt.hbl_SearchList(args0)

      if (ret.KEY_VALUE_PAIRS?.TrxCode !== "Y") {
        console.log('Import TrxCode ≠ Y')
        setTableData([])
        return { success: false, list: [] }
      }

      const list = ret.DataWG1?.retDataList || []
      console.log('Import list length:', list.length)

      // 매핑은 여기서 하지 않고 → 최종 단계에서 한 번에 처리
      return { success: true, list }
    } catch (err) {
      console.error('Import error', err)
      setTableData([])
      return { success: false, list: [] }
    }
  }

  async function hbl_SearchList_Export(hblValue) {
    if (DEBUG) console.log('hbl_SearchList_Export 시작', hblValue)

    const args0 = {
      DOMAIN: "NTLK.ELVIS21.COM",
      OFFICE_CD: "NTLK",
      HBL_NO: hblValue,
    }

    try {
      const ret = await vizSeaHouseMgt.hbl_SearchList(args0)

      if (ret.KEY_VALUE_PAIRS?.TrxCode !== "Y") {
        console.log('Export TrxCode ≠ Y')
        return { success: false, list: [] }
      }

      const list = ret.DataWG1?.retDataList || []
      console.log('Export list length:', list.length)

      return { success: true, list }
    } catch (err) {
      console.error('Export error', err)
      return { success: false, list: [] }
    }
  }

  function convertPC(value) {
    if (!value) return value
    if (value.includes("PREPAID")) return "P"
    if (value.includes("COLLECT")) return "C"
    return ""
  }

  return (
    <div>
      <div className="tracing-wrapper">
        <div className="tracing-box">
          <div className="tracing-title">Tracing Information</div>

          {/* 검색영역 */}
          <form className="tracing-search" onSubmit={handleSearch}>
            <label className="tracing-label">HOUSE B/L</label>
            <input
              className="tracing-input"
              value={houseBl}
              onChange={e => setHouseBl(e.target.value)}
              placeholder="Enter HOUSE B/L"
            />
            <button type="submit" className="tracing-search-btn">
              🔍 조회
            </button>
          </form>

          {/* 테이블 */}
          <div className="tracing-table-wrapper">
            <table className="tracing-table">
              <thead>
                <tr>
                  <th>NO</th>
                  <th>H B/L #</th>
                  <th>ETA(BUSAN)</th>
                  <th>DESTINATION</th>
                  <th>2ND CONNECTING VSL NAME</th>
                  <th>VOYAGE</th>
                  <th>PACKAGE</th>
                  <th>WEIGHT/VOLUME</th>
                  <th>ETD</th>
                  <th>ATD</th>
                  <th>ETA</th>
                  <th>N/F</th>
                  <th>P/C</th>
                </tr>
              </thead>

              <tbody>
                {/* 조회된 데이터 없음 */}
                {searched && tableData.length === 0 && (
                  <tr>
                    <td colSpan="13">조회된 데이터가 없습니다.</td>
                  </tr>
                )}

                {/* 조회된 데이터 있음 */}
                {searched && tableData.length > 0 &&
                  tableData.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.no}</td>
                      <td>{item.hbl}</td>
                      <td>{item.etaBusan}</td>
                      <td>{item.destination}</td>
                      <td>{item.vslName}</td>
                      <td>{item.voyage}</td>
                      <td>{item.package}</td>
                      <td>{item.weightVolume}</td>
                      <td>{item.etd}</td>
                      {/* <td>{item.onbd_ymd}</td> */}
                      <td>{item.issue_ymd}</td>
                      <td>{item.eta}</td>
                      <td>{item.nf}</td>
                      <td>{item.pc}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>

          {/* total count */}
          {searched && (
            <div className="tracing-footer">
              TOTAL B/L Count : <b>{tableData.length}</b>
            </div>
          )}
        </div>
      </div>
      <div className="tracing-footertxt">
        <p>In case of POD: BRASIL (SANTOS, RIO DE JANEIRO), please add “T” to the end of the BL number.</p>
      </div>
    </div>
  )
}
